define('cartware_checkout/components/acceptance',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"text!shoptheme/templates/magnific-popup/default.html",
	"magnific-popup"
], function(
	$,
	_,
	Component,
	BEM,
	PopupHtml
) {
	var _acceptancePopup = null;

	return Component.create({
		$init: function() {

			var overlay = $('#payolution_overlay');

			function displayPayolutionOverlay()
			{
				var wrap = [
					'<div class="popup-wrap">',
					'<div class="popup-body">',
					overlay.html(),
					'</div>',
					'</div>'
				];

				$.magnificPopup.open({ items: {type: "inline", src: wrap.join("")} });
			}

			function removePayolutionOverlay()
			{
				$.magnificPopup.close();
			}

			window.displayPayolutionOverlay = displayPayolutionOverlay;
			window.removePayolutionOverlay = removePayolutionOverlay;
			
		},

		_renderPopup: function(data) {
			if (null === _acceptancePopup) {
				_acceptancePopup = _.template(PopupHtml);
			}

			return _acceptancePopup(data);
		}
	});
});
